import { BaseModel } from './base.model'
import { TariffGroup } from './tariff-group.model'

export class Tariff extends BaseModel<Tariff> {
  static DEFAULT_ATTRIBUTES = { }

  course: string
  description: string
  group: TariffGroup
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/tariff.model.ts